import { ClickedLatLng } from "react-migration/lib/map/typings";
import { Stores, useGlobalState } from "react-migration/lib/persistence/state";
import { getFeaturesAtPosition } from "src/js/stores/siteGeometry/utils";

export const useSitesAtPosition = (clickedLatLng?: ClickedLatLng) => {
  const [{ siteFeatures }] = useGlobalState(Stores.siteGeometry);

  if (!clickedLatLng) return [];

  return getFeaturesAtPosition(siteFeatures, [clickedLatLng.lng, clickedLatLng.lat]);
};
